import { render, staticRenderFns } from "./tour-item.vue?vue&type=template&id=0c2ac0a8&scoped=true&"
import script from "./tour-item.vue?vue&type=script&lang=js&"
export * from "./tour-item.vue?vue&type=script&lang=js&"
import style0 from "./tour-item.vue?vue&type=style&index=0&id=0c2ac0a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ac0a8",
  null
  
)

export default component.exports